import { render, staticRenderFns } from "./AppComponent.vue?vue&type=template&id=f35e43e8&"
import script from "./AppComponent.vue?vue&type=script&lang=js&"
export * from "./AppComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/inventia/Sites/coiico_totem/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f35e43e8')) {
      api.createRecord('f35e43e8', component.options)
    } else {
      api.reload('f35e43e8', component.options)
    }
    module.hot.accept("./AppComponent.vue?vue&type=template&id=f35e43e8&", function () {
      api.rerender('f35e43e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppComponent.vue"
export default component.exports